import React, { useState } from "react";
import "./GridSection.css";

const GridItem = ({ category, onClick }) => {
  const { title, description, image_url, font_color } = category;
  const textColor = font_color || "#FFFFFF";
  const [imageError, setImageError] = useState(false);

  // Build absolute image URL when API returns a relative path
  const buildImageSrc = (url) => {
    if (!url || imageError) {
      return "https://via.placeholder.com/400x400/60A8DC/FFFFFF?text=" + encodeURIComponent(title);
    }
    // Block external hotlink-protected domains
    if (url.includes("publicdomainpictures.net") || url.includes("error.php")) {
      return "https://via.placeholder.com/400x400/60A8DC/FFFFFF?text=" + encodeURIComponent(title);
    }
    if (/^https?:\/\//i.test(url)) return url;
    // Remove /api/ from base and ensure single trailing slash
    const apiBase = process.env.REACT_APP_API || "https://dev.beclutch.club/api/";
    const assetBase = apiBase.replace(/\/api\/?$/, "/");
    const cleanPath = url.startsWith("/") ? url.slice(1) : url;
    return assetBase + cleanPath;
  };
  const imgSrc = buildImageSrc(image_url);

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="grid-item" onClick={onClick}>
      <img 
        src={imgSrc} 
        alt={title}
        className="grid-item-image"
        onError={handleImageError}
      />
      
      {/* Title overlay - always visible in top third */}
      <div className="title-overlay" style={{ color: textColor }}>
        <h3>{title}</h3>
      </div>
      
      {/* Description overlay - shows on hover at bottom */}
      <div className="overlay" style={{ color: textColor }}>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default GridItem;
